<template>
  <div v-if="!!cartorioObj.mensalista"
       class="custom-control custom-switch m-3">
    <div v-if="propOrdemServico">
      <input type="checkbox"
             class="custom-control-input"
             :disabled="!!ordemServicoIdState"
             :checked="mensalistaCheck || propOrdemServico.mensalista_id && propOrdemServico.numero">
      <label class="custom-control-label label"
             for="customSwitch1"
             @click="handlerCheckMensalista">Mensalista</label>
    </div>
    <div v-if="mensalistaCheck || propOrdemServico === null">
      <div class="form">
        <div>
          <label class="label"
                 for="input-cpf">
            CPF ou CNPJ
          </label>
          <b-form-input id="input-cpf"
                        ref="cpf"
                        v-mask="['999.999.999-99', '99.999.999/9999-99']"
                        :state="cpfState"
                        @blur="buscarCPF" />
          <b-form-invalid-feedback id="input-live-feedback">
            Mensalista não encontrado
          </b-form-invalid-feedback>
        </div>
        <div class="col-7 d-flex align-items-center">
          <div class="col-8">
            <label class="label"
                   for="input-nome">
              Nome
            </label>
            <b-form-input id="input-nome"
                          ref="nome"
                          v-model="nome" />
          </div>
          <div v-if="loader"
               class="col pt-4">
            <b-spinner variant="primary"
                       label="Spinning" />
          </div>                          
        </div>
      </div>
      <span class="text-escolher">Escolha uma das opções. {{ propOrdemServico ? 'Caso não Encontre, você precisará adicionar um novo para prosseguir' : '' }}</span>
      <div v-for="mensalista in mensalistas"
           :key="mensalista.mensalista_id"
           class="form-check mt-2">
        <input :id="mensalista.mensalista_id"
               class="form-check-input"
               type="radio"
               name="flexRadioDefault"
               @click="selectMensalista(mensalista)">
        <label class="form-check-label"
               :for="mensalista.mensalista_id">
          <strong>{{ mensalista.cpf_cnpj.length === 11 ? 'CPF: ' : 'CNPJ: ' }}</strong>
          <input v-mask="['999.999.999-99', '99.999.999/9999-99']"
                 class="input-cpf"
                 type="text"
                 :value="mensalista.cpf_cnpj">
          <strong class="ml-2">{{ 'Nome: ' }}</strong> {{ mensalista.nome_empresa }}
        </label>
      </div>
      <div class="mt-3 d-flex align-items-start adiciona-mensalista">
        <AddMenslista v-if="propOrdemServico && !hideBtnAddMensalista"
                      prop-componente-pai="OrdemServicoMensalista"
                      @mensalistaCriado="setaMensalistaCriado" />
      </div>
      <div v-if="propOrdemServico"
           class="observacoes">
        <label for="texto-observacoes">Observações</label>
        <b-form-textarea id="texto-observacoes" 
                         v-model="observacoes"
                         size="lg"
                         :state="observacoesState"
                         @change="emitObservacoes" />
        <b-form-invalid-feedback id="input-live-feedback">
          Máximo de 255 caracteres
        </b-form-invalid-feedback>
      </div>
    </div>
  </div>
</template>

<script>

  // Services
  import MensalistaService from '../mensalistaService'

  // Componentes
  import AddMenslista from '../AddMensalista/AddMensalista.vue'

  export default ({
    name: 'OrdemServicoMensalista',
    components: {
      AddMenslista
    },
    props: {
      propOrdemServico: {type: Object, default: null}
    },
    data () {
      return {
        cartorioObj: null,
        mensalistaCheck: false,
        cpf: null,
        nome: '',
        observacoes: '',
        mensalistas: [],
        validaCPF: null,
        idMensalista: null,
        loader: false,
        hideBtnAddMensalista: false
      }
    },
    computed: {
      cpfState () {
        return this.validaCPF
      },
      observacoesState () {
        if (this.observacoes.length > 255) {
          return false
        }
        return null
      },
      ordemServicoIdState () {
        return this.propOrdemServico.id ? true : false
      }
    },
    watch: {
      async 'nome' () {
        this.validaCPF = null
        
        if (this.nome.length < 3)  return this.mensalistas = []

        try {
          this.loader = true
          // Passe segundo paramentro para refornar apenas mensalistas ativos
          const mensalistas = await MensalistaService.buscarByNome(this.nome, true)
          this.mensalistas = mensalistas
        } catch (err) {

        } finally {
          this.loader = false
        }
      },
      async 'cpf' () {
        if (this.cpf.length < 1) this.validaCPF = null
        const mensalistas = await MensalistaService.buscarByCPF(this.cpf)
        this.mensalistas = mensalistas
        if (this.mensalistas.length < 1) this.validaCPF = false
        if (this.mensalistas.length >= 1) this.validaCPF = true
      },
    },
    created () {
      this.cartorioObj = this.$store.state.auth.cartorioObj
    },
    methods: {
      handlerCheckMensalista () {
        if (this.propOrdemServico.numero) return
        this.hideBtnAddMensalista = false
        this.mensalistaCheck = !this.mensalistaCheck
        this.validaCPF = null
        this.$emit('check')
      },
      async buscarCPF (ev) {
        const cpf = ev.target.value.replace('.', '')
          .replace('.', '')
          .replace('-', '')
          .replace('/', '')
        this.cpf = cpf
      },
      selectMensalista (mensalista) {
        this.hideBtnAddMensalista = true
        this.$emit('addMensalista', mensalista)
      },
      setaMensalistaCriado (mensalista) {
        this.hideBtnAddMensalista = true
        this.$emit('addMensalista', mensalista)
      },
      emitObservacoes () {
        this.$emit('addObservacoes', this.observacoes)
      }
    }
  })
</script>

<style scoped>
.form {
  display: flex;
  gap: 2rem;
  margin-top: 20px;
  margin-bottom: 20px;
  margin-left: -34px;
}
.text-escolher {
  margin-left: -34px;
}
.lista {
  margin-top: 20px;
  margin-bottom: 20px;
  margin-left: -44px;
  list-style: none;
}
.input-cpf {
  border: none;
  outline: none;
  max-width: 150px;
}
.btn-adicionar {
  margin-left: -34px;
}
.numero-cpf {
  border: none;
  outline: none;
  max-width: 170px;
}
.adiciona-mensalista {
  margin-left: -34px;
}
.observacoes {
  margin-left: -34px;
  margin-top: 20px;
  font-weight: 500;
}
.loader {

}

</style>
